var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grow container video-container"},[_c('video',{staticClass:"video-tag",attrs:{"src":(_vm.casePublicAssets + "/videos/message.mp4"),"autoplay":"","controls":"","width":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }